import { Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Solution } from 'src/app/models/service/solution';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { VerticalMenuItem } from 'src/app/models/vertical-menu/vertical-menu-item';
import { KeyValueMap } from 'src/app/models/key-value-map';
import { LineOfBusiness } from 'src/app/models/line-of-business';
import { Constants } from 'src/app/models/constants';
import { combineLatest } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-new-line-of-business',
    templateUrl: './new-line-of-business.component.html',
    styleUrls: ['./new-line-of-business.component.scss'],
    standalone: false
})
export class NewLineOfBusinessComponent implements OnInit {
private destroyRef = inject(DestroyRef);
  solutions: Solution[] = [];
  groupedSolutions = {};

  lineOfBusinessMap: KeyValueMap<string, LineOfBusiness> = {};

  lineOfBusinesses: LineOfBusiness[];
  selectedLineOfBusiness: LineOfBusiness;
  verticalMenuItems: VerticalMenuItem[];

  constructor(private solutionsService: SolutionsService, private activatedRoute: ActivatedRoute,) {
  }

  ngOnInit(): void {
    this.loadData();
  }

  selectLineOfBusiness(lineOfBusiness): void {
    this.selectedLineOfBusiness = lineOfBusiness.data;
  }

  private loadData(): void {
    combineLatest([this.solutionsService.getSolutions(), this.solutionsService.getLineOfBusinesses()])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([solutions, lineOfBusinesses]) => {
        this.solutions = [...solutions];
        lineOfBusinesses.forEach(lineOfBusiness => {
          this.lineOfBusinessMap[lineOfBusiness.name] = lineOfBusiness;
        });
        this.lineOfBusinesses = lineOfBusinesses;

        this.selectedLineOfBusiness = lineOfBusinesses[0];
        this.groupSolutions();
        this.configureVerticalMenu();
      });
  }

  private groupSolutions(): void {
    this.solutions.sort(this.sortSolutionsByName);
    this.solutions.forEach(solution => {
      solution.lineOfBusiness.forEach(lineOfBusiness => {
        if (!this.groupedSolutions[lineOfBusiness]) {
          this.groupedSolutions[lineOfBusiness] = [];
        }
        this.groupedSolutions[lineOfBusiness].push(solution);
      });
    });
  }

  private sortSolutionsByName(firstSolution: Solution, secondSolution: Solution): number {
    const firstSolutionName = firstSolution.name.toUpperCase();
    const secondSolutionName = secondSolution.name.toUpperCase();
    if (firstSolutionName > secondSolutionName) {
      return 1;
    }
    if (secondSolutionName > firstSolutionName) {
      return -1;
    }
  }

  private configureVerticalMenu(): void {
    this.verticalMenuItems = [];
    
    const queryParams  = this.activatedRoute.snapshot.queryParamMap.getAll(Constants.CATALOGUE_FILTER_PARAM);
      for(const item of this.lineOfBusinesses){
      const data = {
        name: item.displayName,
        data: item,
        selected: queryParams.length > 0 ?  queryParams.includes(item.name.toLowerCase()) : false
      };
    
      this.verticalMenuItems.push(data);
    }
   if(queryParams.length === 0){
    this.verticalMenuItems[0].selected = true;
   }
  }

}
